import { denormalize, normalize, schema } from "normalizr";

export const normalizeEntity = (datasources) => {
	const isArray = datasources instanceof Array;
	const dataset = isArray ? "unitOfMeasures" : "unitOfMeasure";
	const unitOfMeasureEntity = new schema.Entity(dataset);
	const result = normalize(
		datasources, 
		isArray ? [unitOfMeasureEntity] : unitOfMeasureEntity
	);
	
	return result.entities;
}

export const denormalizeEntity = (datasources) => {
	const isArray = datasources.unitOfMeasures;
	const dataset = isArray ? "unitOfMeasures" : "unitOfMeasure";
	const unitOfMeasureEntity = new schema.Entity(dataset)
	const entities = isArray ? datasources.unitOfMeasures : datasources.unitOfMeasure;

	return denormalize(
		{ [dataset]: isArray ? Object.keys(entities) : Object.keys(entities).toString() }, 
		{ [dataset]: isArray ? [unitOfMeasureEntity] : unitOfMeasureEntity }, 
		{ [dataset]: entities }
	);
}